import React from 'react';
import ReactDOM from 'react-dom/client';
import {createStore,applyMiddleware, compose} from 'redux'
import thunk from 'redux-thunk'
import {Provider} from 'react-redux'
import {BrowserRouter} from 'react-router-dom';
import reducer from './reducers';
import App from './App';
import history from 'utils/history';
// import { ConnectedRouter } from 'connected-react-router';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)))


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store} >
    <BrowserRouter history={history}>
        <App /> 
    </BrowserRouter>
  </Provider>
);